import React, { Fragment } from "react";
import { Helmet } from "react-helmet";
import DataTable from "../../../../../Common/Components/DataTable";
import { useReportList } from "../../Hooks";
import Loading from "../../../../../Common/Components/Loading";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import CustomModal from "../../../../../Common/Components/Modal/CustomModal";
import TicketItem from "../../../../../../App/Panel/Ticketing/TicketItem";
import { ToTimeJalali } from "../../../../../Common/Function";

function Index({ isApp, reloadPage }) {
  const { getData, loading, list, modal, setModal } = useReportList();
  const navigate = useNavigate();

  useEffect(() => {
    getData();
  }, [reloadPage]);

  const getStatus = (data) => {
    switch (data) {
      case "answerd": return "پاسخ داده شده"
      case "waiting": return "در حال انتظار"
    }
  }

  return (
    <Fragment>
      <Helmet>
        <title>نیکوتن | لیست گزارشات </title>
      </Helmet>

      {isApp &&
        <>
          <p className="mb-3">لیست گزارشات </p>
          {loading
            ? <Loading height={"50px"} count={3} col={"12"} />
            : list?.data?.length > 0
              ? list.data.map(item => (
                <TicketItem number={item.id} title={item.title}
                  date={ToTimeJalali(item.created_at)}
                  status={getStatus(item.status)}
                  clickEV={() => setModal({ visible: true, report: item })}
                />
              ))
              : <p className="text-center mt-3 bg-transparent">  گزارشی وجود ندارد !   </p>
          }
        </>
      }

      {!isApp && <DataTable
        loading={loading}
        needSearch={true}
        heads={[
          {
            title: "عنوان",
            key: "title",
          },
          {
            title: "پیام",
            key: "message",
          },
          {
            title: "نوع دستگاه",
            key: "platform",
            type: "enum",
            enum: {
              ios: "ios",
              android: "اندروید",
              site: "سایت",
            },
          },
          {
            title: "تاریخ ایجاد",
            key: "created_at",
            type: "date",
            timetype: "date-time",
          },
        ]}
        textEmpty=" گزارشی ثبت نشده است"
        list={list.data}
        data={list}
        function={getData}
        currentPage={list && list.current_page}
        header="لیست گزارشات"
        textbtn="ایجاد گزارش اشکال"
        linkbtn="/User/Report/Create"
        links={[
          {
            function: selected => {
              list.data.map(report => {
                if (report.id === selected[0]) {
                  setModal({ visible: true, report });
                }
              });
            },
            color: "danger",
            size: "col-md-3",
            html: "مشاهده",
            type: "show",
            main: true,
          },
        ]}
      />}
      <CustomModal
        show={modal.visible}
        handleClose={() => {
          setModal({ visible: false });
        }}
        header={modal.report && modal.report.title}
      >
        <div>
          <div className="d-flex flex-column justify-content-between">
            <h6>متن پیام</h6>
            <p style={{ fontSize: "12px" }}>
              {modal.report && modal.report.message}
            </p>
          </div>
        </div>
      </CustomModal>
    </Fragment>
  );
}

export default Index;
